/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, December 29th 2021, 5:07:52 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { X } from "react-feather";
import { COLORSCHEME } from "theme/styles";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

interface OSDialogCloseButtonProps extends Pick<IconButtonProps, "onClick">, Partial<Pick<IconButtonProps, "sx">> {
  closeIconButtonComponent?: JSX.Element;
}

export const OSDialogCloseButton = ({ onClick, sx, closeIconButtonComponent }: OSDialogCloseButtonProps) => (
  <IconButton
    aria-label="close"
    onClick={onClick}
    sx={
      sx ?? {
        position: "absolute",
        right: 8,
        top: 8,
      }
    }
  >
    {closeIconButtonComponent ? closeIconButtonComponent : <X color={COLORSCHEME.primary} size="18" />}
  </IconButton>
);
